// CANONICAL COPY (GH #7115). src/constants/obligations/obl-roles-responsibilities.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-roles-responsibilities',
  title: 'Verify information security roles and responsibilities are defined',
  description:
    'Confirm that a document defining IS roles and responsibilities exists, is published, and has been acknowledged by all relevant personnel. Where role definitions are configured in the Employees module, every assigned employee must also have acknowledged the current responsibilities version of their role(s).',
  category: 'governance',
  scfIds: ['SCF-GOV-002'],
  cadence: { frequency: '6m', anchor: 'domain' },
  strategy: 'any',
  fulfilmentCriteria: [
    {
      type: 'roles-acknowledged',
      description: 'Every assigned employee has acknowledged the current version of their role(s)',
    },
    {
      type: 'document-published',
      description: 'A published document defines roles and responsibilities',
    },
    { type: 'document-approved', description: 'Document has been approved' },
    { type: 'document-acknowledged', description: 'All assigned readers have acknowledged' },
  ],
  domainActions: [
    { type: 'deep-link', target: 'employees', label: 'Review Employee Records' },
    { type: 'approve-document', label: 'Approve Document' },
  ],
};
